import React, { ReactNode, useState, useEffect, useContext, createContext } from 'react';
import { useNavigate } from 'react-router';
import { User } from '@firebase/auth';
import { getFirebaseAuth } from '@/lib/firebase';

const AuthContext = createContext<{
  user: User | null;
}>({
  user: null,
});

export const AuthProvider = ({ children }: { children: ReactNode }) => {
  const navigate = useNavigate();
  const [user, setUser] = useState<User | null>(null);
  const auth = getFirebaseAuth();

  useEffect(() => {
    return auth.onIdTokenChanged(async user => {
      try {
        if (!user) {
          setUser(null);
          navigate('/login');
          return;
        }
        setUser(user);
      } catch (error) {
        console.error(error);
      }
    });
  }, [auth]);

  return (
    <AuthContext.Provider
      value={{
        user,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};
